import { useEffect, useState } from "react";
import { Box, Stack, Typography, Paper, CardMedia, Divider, Switch } from "@mui/material";
import { CommonUtils } from "../../../utils/common_utils";
import { userState } from "../../../interface/MainInterface";
import { HttpAdminApi } from "../../../interface/admin-api";
import "./LiveProduct.css";

interface propsType {
  userState: userState;
  channelInfo: any;
  callback: any;
}

type ProdType = {
  goods_cd: string // 상품코드
  goods_nm: string // 상품명
  svc_type: string // 서비스타입
  img_url: string // 상품 이미지 URL
  pc_url: string // pc 렌딩 URL
  mo_url: string // mo 렌딩 URL
  sale_price: string // 판매가
  disp_order: string // 노출 순서
  use_yn: string // 사용여부
}

const cUtils = new CommonUtils();
const adminApi = new HttpAdminApi();

const LiveProduct = (props: propsType) => {
  const [prodList, setProdList] = useState<ProdType[]>([]);
  const [liveProduct, setLiveProduct] = useState<string[]>([]);
  
  useEffect(() => {
    return () => {
      setProdList([]);
      setLiveProduct([]);
    };
  }, []);

  useEffect(() => {
    if (props.channelInfo?.broad_seq !== undefined) {
      get_live_product();
    }
  }, [props.channelInfo]);

  useEffect(() => {
    if (props.channelInfo.broad_prod_list?.length > 0) setProdList(props.channelInfo.broad_prod_list);
  }, [props.channelInfo.broad_prod_list]);

  const get_live_product = async () => {
    const param: any = {
      command: "get_live_product",
      broad_seq: props.channelInfo.broad_seq,
    };

    const res = await adminApi.post(param);
    if (res.code === "200") {
      setLiveProduct(res.response.live_products);
    }
  };

  const set_live_product = async (list: any) => {
    const param: any = {
      command: "set_live_product",
      broad_seq: props.channelInfo.broad_seq,
      list: list,
    };

    await adminApi.post(param);
    props.callback({ command: "change_live_product" });
    get_live_product();
  };

  return (
    <Box className="admin-prod-list" sx={{ height: "calc(100% - 48px)" }} >
      <Box sx={{ p: 1 }}>
        <Stack direction={"column"} spacing={1}>
          {prodList.map((prodInfo: ProdType, index: number) => (
            <Box key={`prod-data-${index}`}>
              <Box sx={{ cursor: "pointer !important" }}>
                <Stack direction={"row"} spacing={1}>
                  <Box>
                    <CardMedia
                      component="img"
                      image={prodInfo.img_url}
                      sx={{ width: "72px", height: "72px", borderRadius: "7px", objectFit: "contain" }}
                      onClick={() => {
                        window.open(prodInfo.pc_url);
                      }}
                    />
                  </Box>
                  <Box
                    sx={{ display: "flex", alignItems: "center", width: "100%" }}
                    onClick={() => {
                      window.open(prodInfo.pc_url);
                    }}
                  >
                    <Stack direction={"column"} spacing={0}>
                      <Typography className={"admin-prod-text-2line"} sx={{ fontWeight: "400" }}>
                        {prodInfo.goods_nm}
                      </Typography>
                      <Stack direction={"row"} spacing={1}>
                        <Typography sx={{ fontWeight: "700", fontSize: "14px" }}>
                          <span>{`${cUtils.numericComma(prodInfo.sale_price)}원`}</span>
                        </Typography>
                      </Stack>
                    </Stack>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "flex-end", minWidth: "70px" }}>
                    <Stack direction={"column"} spacing={0}>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: "700",
                          display: "flex",
                          justifyContent: "center",
                          ...(liveProduct.indexOf(prodInfo.goods_cd) > -1 ? { color: "#ff0000" } : { color: "#000000" }),
                        }}
                      >{`NOW`}</Typography>
                      <Switch
                        checked={liveProduct.indexOf(prodInfo.goods_cd) > -1}
                        onChange={() => {
                          let temp: any = [...liveProduct];
                          if (temp.indexOf(prodInfo.goods_cd) > -1) {
                            for (let i = 0; i < temp.length; i++) {
                              if (temp[i] === prodInfo.goods_cd) {
                                temp.splice(i, 1);
                              }
                            }
                          } else {
                            temp.push(prodInfo.goods_cd);
                          }

                          set_live_product(temp);

                          setLiveProduct(temp);
                        }}
                      />
                    </Stack>
                  </Box>
                </Stack>
              </Box>
              <Box sx={{ pt: 1 }}>
                <Divider />
              </Box>
            </Box>
          ))}
        </Stack>
      </Box>
    </Box>
  );
};

export default LiveProduct;
